// extracted by mini-css-extract-plugin
export default {"mapPageHeader":"kk6F_XmtAFJ70hxZesUC"};